import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { allowancesFilter, allowancesFilterSelection, defaultAllowancesSelection } from 'app/dataProviders/filter-items'


type Props = {
  id: string
  pending: boolean
}

export const AllowancesFilter = ({ id, pending }: Props) => {

  return (
    <PlainItemsSelectorBox
      id={id}
      label="Тип льгот"
      header="Выбор типа льгот"
      dataBoxData={allowancesFilter}
      dataBoxSelection={allowancesFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      defaultSelection={defaultAllowancesSelection}
      disabled={pending}
    />
  )
}
